import { useParams } from 'react-router-dom';
import { useGetOrganizationBySlugQuery } from 'services/organizations';

export const useCompanyNetwork = () => {
  const { networkSlug: slug, employerSlug } = useParams();
  const { data, isLoading, isFetching, isError } = useGetOrganizationBySlugQuery(
    { slug, companySlug: employerSlug },
    {
      skip: !slug || !employerSlug,
    },
  );
  const network = data?.network?.collection;
  return { network, isLoading, isFetching, isError, company: data?.company };
};
